import { render } from "./OnboardingOptions.vue?vue&type=template&id=e9ba141e"
import script from "./OnboardingOptions.vue?vue&type=script&lang=js"
export * from "./OnboardingOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__